import React from 'react';
import { ClipboardCheckIcon, FileTextIcon, GitBranchIcon, LayoutGridIcon, ShieldAlertIcon, ZapIcon } from 'lucide-react';
import { Section, SectionHeading } from '../Section';
import { CtaButton } from '../CtaButton';
const pillars = [{
  icon: FileTextIcon,
  label: 'Protocols'
}, {
  icon: GitBranchIcon,
  label: 'Decision Maps'
}, {
  icon: ClipboardCheckIcon,
  label: 'Checklists'
}, {
  icon: ShieldAlertIcon,
  label: 'Risk Matrices'
}, {
  icon: LayoutGridIcon,
  label: 'Case Planning Tools'
}, {
  icon: ZapIcon,
  label: 'Quick References'
}];
export function CreatedBy() {
  return <Section tone="light" data-id="element-144" data-mp="o9yqb7jdmc7a">
      <SectionHeading invert eyebrow="Created by Dr. Karito" title="A practical approach to clinical decision-making" data-id="element-145" data-mp="o8dyvqscz9dn" />

      <div className="mt-9 grid items-start gap-6 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)]" data-id="element-146" data-mp="xa3yvl0b3gn1">
        <img src="https://cdn.magicpatterns.com/uploads/gXuKCBT2jbf2PQRys87Hyh/Dra._Karito_Odontologa.png" alt="Dr. Karito, dentist and creator of the Oclusion Clinical Playbook, in her clinic" className="w-full rounded-2xl object-cover shadow-xl shadow-navy-950/20" width={945} height={1560} loading="lazy" data-id="element-147" data-mp="t91yh0unkyjh" />

        <div className="space-y-4 text-[15px] leading-relaxed text-slate-700 sm:text-base" data-id="element-148" data-mp="1klw6sbby37sr">
          <p data-id="element-149" data-mp="1pgjq7vs3dc0h">
            After years of studying, teaching and working with complex restorative and rehabilitation
            cases, Dr. Karito recognized a recurring problem among dentists:
          </p>
          <p className="font-display text-xl font-bold leading-snug text-navy-950 sm:text-2xl" data-id="element-150" data-mp="1ygyb4u158p3g">
            They didn’t need another lecture. They needed a way to organize their clinical reasoning
            when faced with a complex case.
          </p>
          <p data-id="element-151" data-mp="2d9i9zih9gaf3">
            That’s why she created the Oclusion Clinical Playbook™. Instead of another traditional
            textbook or lengthy course, the material is structured around six practical building
            blocks:
          </p>

          <ul className="grid grid-cols-2 gap-2.5 pt-1" data-id="element-152" data-mp="1sgtnrf9iy3ve">
            {pillars.map(pillar => <li key={pillar.label} className="flex items-center gap-2.5 rounded-xl border border-navy-950/10 bg-white p-3 text-[13px] font-bold leading-tight text-navy-950 sm:text-sm" data-id="element-153" data-mp="1ni8mdcijde5d">
                <pillar.icon className="h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-154" data-mp="2b8uq4rlicc9k" />
                {pillar.label}
              </li>)}
          </ul>

          <p data-id="element-155" data-mp="2l7to9g8ncpib">
            A system designed to help dentists move from scattered information to a more structured
            clinical workflow.
          </p>
        </div>
      </div>

      <div className="mt-9 flex justify-center" data-id="element-156" data-mp="2g6w9ldmuidlk">
        <CtaButton label="Get the Playbook system" subLabel="Instant access · Lifetime reference" data-id="element-157" data-mp="quu5je8yzf6t" />
      </div>
    </Section>;
}